import React from "react";
import { Link } from "react-router-dom";
import { t } from "../../lib/i18n";

export default function BigCtaBand() {
  return (
    <section
      data-testid="home-cta-band"
      className="bg-[#C8A24B]"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-6 px-5 py-14 sm:px-6 sm:py-20 md:flex-row md:items-center md:justify-between">
        <div className="max-w-xl">
          <h2 className="font-display text-3xl leading-tight text-[#1A1A1A] sm:text-4xl lg:text-5xl">
            {t("home.cta.title")}
          </h2>
          <p className="mt-3 text-sm text-[#1A1A1A]/75 sm:text-base">
            {t("home.cta.subtitle")}
          </p>
        </div>
        <Link
          to="/plan"
          data-testid="home-cta-band-button"
          className="inline-flex items-center rounded-full bg-[#1A1A1A] px-8 py-3.5 text-xs uppercase tracking-[0.22em] text-[#FAF7F2] transition hover:bg-[#2a2a2a]"
        >
          {t("home.cta.button")}
        </Link>
      </div>
    </section>
  );
}
